<template>
  <el-collapse v-model="activeNames" class="collapse-quote-list-versions">
    <el-collapse-item name="1" class="versions-collapse-item">
      <template slot="title">
        <div class="versions-header">
          <div class="versions-header-left">
            <img class="versions-icon" :src="icoVersions" alt="" />
            <span class="versions-title">Versiones Anteriores</span>
          </div>
          <span class="versions-count">{{ quote.versions.length }}</span>
        </div>
      </template>

      <div
        class="version-item"
        :class="{ 'version-item--active': version.id === versionActived }"
        v-for="(version, index) in quote.versions"
        :key="index"
        @click="quoteView(version)"
      >
        <div class="version-item-row">
          <span class="version-badge">v{{ version.version_number }}</span>
          <span class="version-name">{{ version.name }}</span>
          <span class="version-date">{{ version.created_at }}</span>
          <span class="version-total">${{ version.total }}</span>
        </div>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { icoVersions } from "@/services/resources";

export default {
  name: "QuoteListVersionsComponent",
  data() {
    return {
      icoVersions,
      activeNames: [],
      versionActived: null
    };
  },
  methods: {
    goRouter(name, params = {}) {
      this.$router.push({ name, params });
    },
    quoteView(version) {
      this.versionActived = version.id;
      this.$emit("onClickVersion", version);
      this.goRouter("sales.quotes.view", {
        id: this.quote.id,
        idVersion: version.id
      });
    }
  },
  props: {
    quote: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
/* Header del collapse */
.versions-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 8px;
}

.versions-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.versions-icon {
  width: 20px;
  height: 20px;
  opacity: 0.7;
}

.versions-title {
  font-size: 14px;
  font-weight: 600;
  color: #31355c;
}

.versions-count {
  background: #eef1f7;
  color: #31355c;
  font-size: 11px;
  font-weight: 700;
  width: 24px;
  height: 24px;
  line-height: 24px;
  border-radius: 50%;
  text-align: center;
  flex-shrink: 0;
}

/* Collapse item container */
.versions-collapse-item {
  background: #fff;
  border-radius: 12px !important;
  border: 1px solid #e8ecf2;
  padding: 4px 8px;
  margin: 8px 0 20px 0;
  overflow: hidden;
}

/* Individual version item */
.version-item {
  cursor: pointer;
  padding: 12px 16px;
  margin: 4px 0;
  border-radius: 10px;
  border: 1px solid transparent;
  transition: all 0.2s ease;

  &:hover {
    background: #f7f8f9;
    border-color: #e8ecf2;
    box-shadow: 0 2px 8px rgba(49, 53, 92, 0.06);
    transform: translateY(-1px);
  }

  &--active {
    background: #f0fdf9;
    border-color: #3fdbbf;
    border-left: 3px solid #3fdbbf;

    .version-badge {
      background: #3fdbbf;
      color: #fff;
    }
  }
}

/* Row layout */
.version-item-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.version-badge {
  background: #eef1f7;
  color: #31355c;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 12px;
  white-space: nowrap;
  text-transform: uppercase;
  display: inline-block;
  min-width: auto;
  letter-spacing: 0.5px;
  transition: all 0.2s ease;
}

.version-name {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: #31355c;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.version-date {
  font-size: 13px;
  font-weight: 500;
  color: #9ca3af;
  white-space: nowrap;
}

.version-total {
  font-size: 15px;
  font-weight: 700;
  color: #31355c;
  white-space: nowrap;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .version-item-row {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: auto auto;
    gap: 2px 10px;
    align-items: center;
  }

  .version-badge {
    grid-row: 1;
    grid-column: 1;
    justify-self: start;
    width: fit-content;
  }

  .version-name {
    grid-row: 1;
    grid-column: 2;
    font-size: 13px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .version-total {
    grid-row: 1;
    grid-column: 3;
    text-align: right;
    font-size: 14px;
  }

  .version-date {
    grid-row: 2;
    grid-column: 1 / -1;
    font-size: 12px;
  }

  .version-item {
    padding: 10px 12px;
  }
}
</style>
